import PopInfo from "components/info-popup/pop-info";
import {useState,useMemo} from "react";
import Input from "components/input/input";
import Select from "components/select/select";
import AutoCompleteAddress from "components/google-address/auto-complete";
import CreatableSelect from "components/select/creatable";
import { useOccupations } from "redux/modules/occupation/hooks";

const AboutYou = ({t, userData ,setState =()=>{},state={},
                    setOccupation = ()=>{}, occupation, profile,positionOptions,setPositionOptions})=>{
    const gender = [
        { label: t("male"), value: "Male" }, 
        { label: t("female"), value: "Female" },
        { label: t("other"), value: "Other" }
    ];
    const { http } = global.services;
    
    const {
        occupations,
        addOccupation,
    } = useOccupations();
    // console.log('-------------------------------')
    // console.log(occupations)
    console.log(occupations.filter(item => item.profile_type === 'personal'))
    const onChangeOccupation = (e) => {
        let insertPosition = [];
        setOccupation(e);
        e.forEach(async (item) => {
            const exists = positionOptions.some(position => position.label === item.label);
            if (!exists) {
                insertPosition.push(item.label);
                try {
                    await setPosition(item.label); 
                    console.log(`Created position: ${item.label}`);
                } catch (error) {
                    console.error(`Failed to create ${item.label}`, error);
                }
            }
        });


        console.log(e);
    };

  const createOccupation = async (value) => {
    try {
      let { data } = await http.post("public/occupations", {
        user_id: userData.user.id,
        user_profile_id: userData.profile.id,
        occupation: value,
      });
      setOccupation((prev) => [...prev, { label: value, value: data.data.id }]);
      addOccupation({
        label: value,
        value: data.data.id,
      });

    const newItem = { label: value, value: data.data.id };
    const exists = positionOptions.some(position => position.label === newItem.label);

    if (!exists) {
        try {
            await setPosition(newItem.label);
            console.log(`Created position: ${newItem.label}`);
        } catch (error) {
            console.error(`Failed to create ${newItem.label}`, error);
        }
    }

    } catch (err) {
      console.log(err);
    }
  };
    
    const handleInputChange = (e, others_name = false) => {
        const { name, value } = e.target; 
        if(others_name){
            setState((prev) => ({
              ...prev,
              [name]: value,
              other_name: value,
              validationErrors: { ...state.validationErrors, [name]: null },
            })); 
            return;
        } 
        setState((prev) => ({
          ...prev,
          [name]: value,
          validationErrors: { ...state.validationErrors, [name]: null },
        }));
      };

    const setPosition = async(label)=>{
        let { data } = await http.post("/public/positions", {
            user_id: profile.user.id,
            user_profile_id: profile.id,
            position: label,
        });
        setPositionOptions(prev => 
            [...prev, { value: data.data.id, label: label }]
                .sort((a, b) => a.label.localeCompare(b.label))
            );
        
    }

    const showGender = useMemo(() => {
        let hasGender = !gender.filter((g) => g.value === state.gender).length;
        if (state.gender && state.gender != "null") {
        if (state.gender === "Other" || hasGender) {
            return true;
        } else {
            return false;
        }
        } else {
        return false;
        }
    }, [state.gender]);

    const handleAddressChange = (fieldName, addressValue) => {
    setState((prev) => ({
      ...prev,
      [fieldName]: addressValue,
      validationErrors: { ...prev.validationErrors, [fieldName]: null },
    }));
  };
  const handleSelectAddress = (parsed) => {
    setState((prev) => ({
      ...prev,
      city: parsed.city,
      state: parsed.state,
      country: parsed.country,
    }));
  };

    return(
        <div className="px-2">
            <div>
                <h1 className="font-semibold text-base 2sm:text-lg">A Little About You</h1>
                <p className="text-xs 2sm:text-base">Tell us more about yourself by adding some basic personal details.</p>
            </div>
            <div className="mt-2">
                <div className="w-full mb-2 2sm:mb-5 3md:mb-0">
                    <div className="w-full flex flex-row gap-x-2 items-center">
                        <p className="text-lg text-lightBlack font-semibold">
                        {t('personalInformation')}
                        </p>
                        {/* <PopInfo
                        containerClass="relative"
                        type="personal_information_general"
                        responsive={{
                            left: "200px",
                            right: "200px",
                            handleInputChange
                        }}
                        /> */}
                    </div>
                    <div className="w-full gap-4">
                        <div className="flex flex-col gap-0 md:gap-2 md:flex-row w-full">
                            <div className="flex-1">
                                <Select
                                    label={t("gender")}
                                    options={gender}
                                    placeholder={t("selectGender")}
                                    name="gender"
                                    className="h-[3rem]"
                                    value={
                                        state.gender &&
                                        gender.filter((g) => g.value === state.gender)
                                    }
                                    onChange={(e) =>
                                        handleInputChange({
                                        target: { name: "gender", value: e.value },
                                        })
                                    }
                                    labelClass={`text-sm font-bold text-darkerGray leading-4 marked`}
                                    errorMessage={state.validationErrors?.gender}
                                    formContainer="mb-1"
                                /> 
                            </div>
                        </div>
                        {showGender && (
                            <Input
                                inputContainerClass="mb-1"
                                outsideLabelClass="text-sm font-bold text-darkerGray mr-4"
                                value={state.other_gender || ""}
                                outsideLabel={t("specify")}
                                //outsideLabel="Specify Gender"
                                noLabelPaddingY="1rem"
                                type="text"
                                errorMessage={state.validationErrors?.other_gender}
                                onChange={(e) =>
                                handleInputChange({
                                    target: {
                                    name: "other_gender",
                                    value: e.target.value,
                                    },
                                })
                                }
                            />
                            )}
                        
                        <div className="mb-1 mt-2">
                            <label for="address" className="text-sm font-bold text-darkerGray leading-4">{t('location_egCityStateCountry')}</label>
                            <div className="mt-1">
                                <AutoCompleteAddress
                                name="address"
                                value={state?.address}
                                onChange={handleAddressChange}
                                onSelect={(parsed) => { handleSelectAddress(parsed);}}
                                placeholder="Melbourne VIC, Australia"
                                errorMessage={state.validationErrors?.birth_location}
                                formContainer="mb-1"
                                combineCityCountry = {true}
                                // match the height of the Gender / Occupations selects (52px)
                                inputStyle={{ height: "52px", padding: "0 1rem", boxSizing: "border-box" }}
                                />
                            </div>
                        </div>
                        <CreatableSelect
                            className="capitalize mb-1"
                            labelClass={`text-sm font-bold text-darkerGray leading-4 marked`}
                            label={`${t('occupationsSkills')} (eg. Actor, Director)`}
                            options={occupations.filter(item => item.profile_type === 'personal')}
                            placeholder={t("selectOccupations")}
                            name="occupations"
                            isMulti
                            value={occupation}
                            onChange={(e) => onChangeOccupation(e)}
                            onCreateOption={createOccupation}
                            formContainer="mb-1"
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutYou;